import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useFileRouteParams } from '../FileRoute/utils/getFileRouteParams'
import type { FolderStore } from '../Folder/FolderStore'
import { FileRouteLink } from '../FileRouteLink/FileRouteLink'
import SvgListDashes from '@jotta/ui/SvgListDashes'
import SvgGrid from '@jotta/ui/SvgGrid'
import { SelectionActions } from './SelectionActions'

const debug = Debug('jotta:files:PathItemRow')

export const FileBrowserToolbar = observer<{
  folder: FolderStore
}>(function FileBrowserToolbar({ folder }) {
  const { context } = useFileRouteParams()
  const isSearch = context === 'search'
  const { selection, someSelected: indeterminate } = folder

  useEffect(() => {
    selection.setIndeterminate(indeterminate)
  }, [selection, indeterminate])

  const nextViewMode = folder.route.viewMode === 'list' ? 'thumbs' : 'list'
  const viewModeIcon = nextViewMode === 'list' ? SvgListDashes : SvgGrid
  return (
    <div className="h-[56px] flex-none shrink-0 bg-primary py-1">
      {!folder.selectedChildren.length ? (
        <div className="flex h-full grow justify-end pr-[10px]">
          <FileRouteLink
            data-testid={`ViewMode${nextViewMode === 'list' ? 'List' : 'Thumbs'}Button`}
            viewMode={nextViewMode}
            replace={isSearch}
          >
            <PlainBrandIcon className="w-6" icon={viewModeIcon} />
          </FileRouteLink>
        </div>
      ) : (
        <SelectionActions folder={folder} />
      )}
    </div>
  )
})
